const KEY = 'cast_pending_heartbeat';

/** Queue a heartbeat that couldn't be sent because the token was invalid/expired.
 *  Overwrites any previous pending entry — only the latest matters. */
export function savePendingHeartbeat(payload) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...payload, savedAt: Date.now() }));
  } catch {
    // best-effort only
  }
}

export function getPendingHeartbeat() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Drop anything stale (>24h) — the watch session it belonged to is long gone.
    if (!parsed?.savedAt || Date.now() - parsed.savedAt > 24 * 60 * 60 * 1000) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingHeartbeat() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // best-effort only
  }
}
